export default "__VITE_ASSET__BPg$MmI4__"